import { QueryType } from '../../../utils/apollo/graphqlSchema';
import { IPersistState } from './types';
import { CURRENT_PERSIST_STATE_VERSION } from './utils';
import { UnreachableCaseError } from 'ts-essentials';
import { IChartSettings } from '../../../components/Chart/interfaces';

export default ({
  queryType,
  chartSettings,
  activeIncidentTypes,
}: {
  queryType: QueryType;
  chartSettings: IChartSettings;
  activeIncidentTypes: Record<string, boolean>;
}) => {
  switch (queryType) {
    case QueryType.Expression: {
      const persistState: IPersistState = {
        version: CURRENT_PERSIST_STATE_VERSION,
        activeIncidentTypes,
        chartSettings,
      };
      return JSON.stringify(persistState);
    }
    case QueryType.Funnel: {
      const persistState: IPersistState = {
        version: CURRENT_PERSIST_STATE_VERSION,
        activeIncidentTypes,
        chartSettings,
      };
      return JSON.stringify(persistState);
    }
    case QueryType.DataTable: {
      const persistState: IPersistState = {
        version: CURRENT_PERSIST_STATE_VERSION,
        chartSettings,
      };
      return JSON.stringify(persistState);
    }
    case QueryType.Path: {
      const persistState: IPersistState = {
        version: CURRENT_PERSIST_STATE_VERSION,
        chartSettings,
      };
      return JSON.stringify(persistState);
    }
    case QueryType.Retention: {
      const persistState: IPersistState = {
        version: CURRENT_PERSIST_STATE_VERSION,
        chartSettings,
      };
      return JSON.stringify(persistState);
    }
    // We don't support persisting these query types
    case QueryType.Significance:
    case QueryType.CohortSample:
    case QueryType.Prediction:
      return JSON.stringify({});
    default: {
      throw new UnreachableCaseError(queryType);
    }
  }
};
